import React, { useState } from "react";
import { AiOutlineLoading } from "react-icons/ai";
import { FaTimes } from "react-icons/fa";
import { useAdminContext } from "../../../context/admin/context/AdminContext";

const PromoteContent = ({ onClick, ids = [], visible, setVisible, loading }) => {
  const { sysAdmin } = useAdminContext();
  const isSuperAdmin = ["super_admin", "admin"].includes(sysAdmin?.role);
  const [selectedPosition, setSelectedPosition] = useState(-1);

  if (!visible || !isSuperAdmin) return null;

  const Positions = [
    { position: "1", state: ids?.find(c => parseInt(c?.position) === 1), title: ids?.find(c => parseInt(c?.position) === 1)?.title || null },
    { position: "2", state: ids?.find(c => parseInt(c?.position) === 2), title: ids?.find(c => parseInt(c?.position) === 2)?.title || null },
    { position: "3", state: ids?.find(c => parseInt(c?.position) === 3), title: ids?.find(c => parseInt(c?.position) === 3)?.title || null },
    { position: "4", state: ids?.find(c => parseInt(c?.position) === 4), title: ids?.find(c => parseInt(c?.position) === 4)?.title || null },
    { position: "5", state: ids?.find(c => parseInt(c?.position) === 5), title: ids?.find(c => parseInt(c?.position) === 5)?.title || null },
    { position: "6", state: ids?.find(c => parseInt(c?.position) === 6), title: ids?.find(c => parseInt(c?.position) === 6)?.title || null },
    { position: "7", state: ids?.find(c => parseInt(c?.position) === 7), title: ids?.find(c => parseInt(c?.position) === 7)?.title || null },
    { position: "8", state: ids?.find(c => parseInt(c?.position) === 8), title: ids?.find(c => parseInt(c?.position) === 8)?.title || null },
    { position: "9", state: ids?.find(c => parseInt(c?.position) === 9), title: ids?.find(c => parseInt(c?.position) === 9)?.title || null },
    { position: "10", state: ids?.find(c => parseInt(c?.position) === 10), title: ids?.find(c => parseInt(c?.position) === 10)?.title || null },
    { position: "11", state: ids?.find(c => parseInt(c?.position) === 11), title: ids?.find(c => parseInt(c?.position) === 11)?.title || null },
    { position: "12", state: ids?.find(c => parseInt(c?.position) === 12), title: ids?.find(c => parseInt(c?.position) === 12)?.title || null },
    { position: "13", state: ids?.find(c => parseInt(c?.position) === 13), title: ids?.find(c => parseInt(c?.position) === 13)?.title || null },
    { position: "14", state: ids?.find(c => parseInt(c?.position) === 14), title: ids?.find(c => parseInt(c?.position) === 14)?.title || null },
    { position: "15", state: ids?.find(c => parseInt(c?.position) === 15), title: ids?.find(c => parseInt(c?.position) === 15)?.title || null },
    { position: "16", state: ids?.find(c => parseInt(c?.position) === 16), title: ids?.find(c => parseInt(c?.position) === 16)?.title || null },
  ];

  const btnBase =
    "inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2";
  // const btnNeutral =
  //   "bg-white text-slate-700 border-slate-200 hover:bg-slate-50";
  const btnPrimary =
    "bg-blue-600 text-white border-blue-600 hover:bg-blue-500 focus-visible:ring-blue-500 disabled:opacity-60 disabled:cursor-not-allowed";

  return (
    <div className="fixed inset-0 z-[2147483647]">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-[2px]" />
      <div className="absolute inset-0 flex items-start justify-center p-4 sm:p-6">
        <div className="w-full max-w-2xl bg-white rounded-2xl border border-slate-200 shadow-2xl overflow-hidden">
          <div className="sticky top-0 z-10 flex items-center justify-between px-5 py-4 border-b bg-white/95 backdrop-blur">
            <span className="text-lg font-semibold text-slate-900">Promote Content</span>
            <button
              onClick={() => {
                setVisible(false);
                setSelectedPosition(-1);
              }}
              className="p-2 rounded-full text-slate-600 hover:bg-slate-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
              aria-label="Close"
            >
              <FaTimes className="text-xl" />
            </button>
          </div>

          <div className="px-5 pt-4 pb-2">
            <div className="flex items-center justify-between">
              <div className="text-sm text-slate-600">Select a position below</div>
              <div className="flex items-center gap-4 text-xs">
                <div className="flex items-center gap-2 text-slate-600">
                  <span className="inline-block w-2.5 h-2.5 rounded-full bg-slate-900" />
                  <span>Occupied</span>
                </div>
                <div className="flex items-center gap-2 text-slate-600">
                  <span className="inline-block w-2.5 h-2.5 rounded-full border border-slate-400" />
                  <span>Empty</span>
                </div>
              </div>
            </div>
          </div>

          <div className="px-5 pb-2 max-h-[58vh] overflow-y-auto">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
              {Positions?.map((position, key) => {
                const isSelected = selectedPosition === key;
                const isTaken = !!position.state;
                const base =
                  "w-full min-h-[82px] rounded-xl border px-3 py-2.5 flex flex-col items-center justify-center text-center cursor-pointer transition-all";
                const taken =
                  "bg-slate-900 text-white border-slate-900";
                const empty =
                  "bg-white text-slate-800 border-slate-300 hover:bg-slate-50";
                const selected =
                  "ring-2 ring-blue-500 border-blue-600 bg-blue-50 text-blue-800";
                return (
                  <div key={key} className="h-full">
                    <div
                      onClick={() => setSelectedPosition(key)}
                      className={`${base} ${isSelected ? selected : isTaken ? taken : empty}`}
                    >
                      <span className="text-sm font-semibold leading-none">
                        {String(position.position).padStart(2, "0")}
                      </span>
                      <p className="text-xs mt-1 line-clamp-2">
                        {position?.title || (isTaken ? "Occupied" : "Empty")}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="px-5 py-5 border-t bg-white">
            {loading ? (
              <div className="w-full flex justify-center items-center py-1">
                <AiOutlineLoading className="animate-spin text-2xl text-blue-600" />
              </div>
            ) : (
              <button
                disabled={selectedPosition === -1}
                onClick={() =>
                  selectedPosition !== -1 ? onClick(selectedPosition + 1) : null
                }
                className={`${btnBase} ${btnPrimary} w-full justify-center`}
              >
                Promote
                {selectedPosition !== -1
                  ? ` (Position ${selectedPosition + 1})`
                  : ""}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoteContent;
